<div class="wrapper">
	@if (!isError && data) {
		@let vsnFeeBenefitFF = vsnFeeBenefitFF$ | async;
		@let showBenefit =
			vsnFeeCollection?.globalOptIn &&
			vsnFeeCollection?.eligibleForVsn &&
			vsnFeeCollection?.visionFeeDetail?.hasEnoughFunds &&
			vsnFeeCollection?.enabled;

		<dl class="fee-transparency">
			<dt>{{ "fee_transparency_details_swap_volume" | translate }} </dt>
			<dd>{{
				data.netValue
					| tradable_precision_symbol
						: {
								id: targetTradable?.getId(),
								ignorePrecision: true,
								txPrecision: true,
								noTrailingZeros: true
						  }
			}}</dd>

			<dt>{{ "trans_fee_swap_amount" | translate }}</dt>
			<dd>{{
				data.swapAmount
					| tradable_precision_symbol
						: { id: sourceTradable?.getId(), txPrecision: true, noTrailingZeros: true }
			}}</dd>

			<dt>{{ "trans_fee_offer_price" | translate }}</dt>
			<dd
				>{{
					data.sourceAmount
						| tradable_precision_symbol
							: { id: sourceTradable?.getId(), txPrecision: true, noTrailingZeros: true }
				}}
				≈
				{{
					data.targetAmount
						| tradable_precision_symbol
							: { id: targetTradable?.getId(), txPrecision: true, noTrailingZeros: true }
				}}</dd
			>

			<!-- Normal summary (no VSN benefit) -->
			@if (!showBenefit) {
				<dt>{{ "trans_fee_trade" | translate }}</dt>
				<dd>{{
					data.feeAmount | fiat_precision_symbol: { id: fiat.getId(), currencies: [fiat], symbol: true }
				}}</dd>
			}
			<!-- Normal summary (no VSN benefit) -->
		</dl>

		<!-- VSN fee transparency detail -->
		@if (vsnFeeBenefitFF && showBenefit) {
			<vision-fee-trans-detail-ui
				[fiat]="fiat"
				[tradable]="sourceTradable"
				[vsnFeeCollection]="vsnFeeCollection"
				[fee]="+data.feeAmount" />
		}

		<!-- VSN fee transparency detail -->
	} @else {
		<p class="error">{{ "fee_transparency_data_error" | translate }}</p>
	}
	<p class="description">{{ "trans_fee_description" | translate }}</p>
</div>
